kombi.flight = {
    bindDeltaPricing: function () {
        if (kombi.flight._deltaPricingBound) {
            return;
        }

        const recalcFlightDeltaPricing = function (event) {
            const targetId = event.detail.target && event.detail.target.id;

            if (targetId === 'flight_results_list') {
                kombi.flight.calculateDeltaPricing();
            }
        };

        document.body.addEventListener('htmx:afterSwap', recalcFlightDeltaPricing);
        document.body.addEventListener('htmx:afterSettle', recalcFlightDeltaPricing);

        kombi.flight._deltaPricingBound = true;
    },
    syncPackageCheckoutVisibility: function (formEl) {
        if (!formEl || !formEl.getAttribute || formEl.getAttribute('data-package-checkout-card') !== '1') {
            return;
        }

        const cartDepartureFlightId = formEl.getAttribute('data-package-cart-flight-departure-id');
        const cartArrivalFlightId = formEl.getAttribute('data-package-cart-flight-arrival-id');
        const checkoutEl = formEl.querySelector('.js-package-direct-checkout');
        const resubmitEl = formEl.querySelector('.js-package-resubmit-flight');

        if (!cartDepartureFlightId || !cartArrivalFlightId || !checkoutEl || !resubmitEl) {
            return;
        }

        const departureInput = formEl.querySelector('input[name="flightCardDepartureFlight"]:checked');
        const arrivalInput = formEl.querySelector('input[name="flightCardArrivalFlight"]:checked');

        if (!departureInput || !arrivalInput) {
            return;
        }

        const matches =
            String(departureInput.value) === String(cartDepartureFlightId) &&
            String(arrivalInput.value) === String(cartArrivalFlightId);

        if (matches) {
            checkoutEl.classList.remove('d-none');
            resubmitEl.classList.add('d-none');
        } else {
            checkoutEl.classList.add('d-none');
            resubmitEl.classList.remove('d-none');
        }
    },
    initPackageCheckoutVisibility: function () {
        document.querySelectorAll('form[data-package-checkout-card="1"]').forEach(function (form) {
            kombi.flight.syncPackageCheckoutVisibility(form);
        });
    },
    bindPackageCheckoutVisibility: function () {
        if (kombi.flight._packageCheckoutBound) {
            return;
        }

        const resyncFlightResultsList = function (event) {
            const targetId = event.detail.target && event.detail.target.id;

            if (targetId === 'flight_results_list') {
                kombi.flight.initPackageCheckoutVisibility();
            }
        };

        document.body.addEventListener('change', function (event) {
            const el = event.target;

            if (!el.classList || !el.classList.contains('flightCheck')) {
                return;
            }

            const pkgForm = el.closest('form[data-package-checkout-card="1"]');

            if (pkgForm) {
                kombi.flight.syncPackageCheckoutVisibility(pkgForm);
            }
        });

        document.body.addEventListener('htmx:afterSwap', resyncFlightResultsList);
        document.body.addEventListener('htmx:afterSettle', resyncFlightResultsList);

        kombi.flight._packageCheckoutBound = true;
    },
    calculateDeltaPricing: function () {
        if (!kombi.deltaPricing) {
            return;
        }

        kombi.deltaPricing.calculate('#flight_results_list');
    },
    changeDateMobile: function () {
        let buttons = document.querySelectorAll('.changeDateButton');
        if (window.innerWidth < 768) {
            buttons.forEach(function (button) {
                button.setAttribute('data-bs-toggle', 'modal');
                button.setAttribute('data-bs-target', '#SearchForm');
            });
        } else {
            buttons.forEach(function (button) {
                button.removeAttribute('data-bs-toggle');
                button.removeAttribute('data-bs-target');
            });
        }
    },
    changeDateDesktop: function (room_id, element) {
        if (!room_id || !element) {
            return;
        }
        
        document.querySelectorAll('.modal').forEach(modal => {
            let modalInstance = bootstrap.Modal.getInstance(modal);
            if (modalInstance) {
                modalInstance.hide();
            }
        });

        setTimeout(() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 200);

        setTimeout(() => {
            let calendarElement = null;
            if (window.innerWidth < 768) {
                calendarElement = document.getElementById('search-calendar-mobile');
            } else {
                calendarElement = document.getElementById('search-calendar-desk');
            }

            if (calendarElement) {
                    if (kombi.flatpickrInstances && kombi.flatpickrInstances.length > 0) {
                        for (let i = 0; i < kombi.flatpickrInstances.length; i++) {
                            const fp = kombi.flatpickrInstances[i];
                            if (fp.input && calendarElement.contains(fp.input)) {
                                fp.open();
                                return;
                            }
                        }
                    }
            }
        }, 600);
    },
    moreFlights: function (event) {
        let moreFlightsButton = event.target;
        let moreFlightsDivs = moreFlightsButton.closest('.flights-card').querySelectorAll('.more-flights-flightCard');
        moreFlightsDivs.forEach(function(div) {
            if (div.classList.contains('show')) {
                moreFlightsButton.innerHTML = 'Ver mais opções de horários<i class="fa-solid fa-chevron-down ms-1"></i>';
                div.classList.remove('show');
            } else {
                moreFlightsButton.innerHTML = 'Ver menos opções de horários<i class="fa-solid fa-chevron-up ms-1"></i>';
                div.classList.add('show');
            }
        });
    },
    selectionButton: function (button, multi_offer_form_id) {
        var allSelectionButtons = document.querySelectorAll('.spinner-disabled');
        allSelectionButtons.forEach(function(btn) {
            btn.disabled = true;
        });
    
        var buttonText = button.querySelector('.buttonText');
        var buttonSpinner = button.querySelector('.buttonSpinner');
        buttonText.classList.add('d-none');
        buttonSpinner.classList.remove('d-none');
    
        var formObj = document.getElementById(multi_offer_form_id);
        var formData = new FormData(formObj);
        var selectionString = '&selectedFlight=';
        selectionString += formData.get('multi_offer_id') + '.';
        selectionString += formData.get('flightCardDepartureFlight') + '.';
        selectionString += formData.get('flightCardArrivalFlight');
    
        formObj.action = formObj.action + selectionString;
        if (formObj.hasAttribute('hx-post')) {
            formObj.setAttribute('hx-post', formObj.action);
        }
        if (typeof formObj.requestSubmit === 'function' && formObj.hasAttribute('hx-post')) {
            formObj.requestSubmit();
        } else {
            formObj.submit();
        }
    },
    /**
     * Starts the rotating copy inside the async flight loader.
     * Reusable across flight results page and package hotel poller.
     *
     * Keeps a single interval; it reads the "live" DOM each tick so HTMX swaps don't break it.
     *
     * @param {ParentNode} root Element/document to search within
     */
    startLoaderTextRotation: function (root) {
        const isGlobalRotation = !root || root === document;

        // If an interval exists but the "mode" changed (document vs scoped),
        // restart so we always query the correct live DOM.
        if (
            kombi.flight._loaderTextIntervalId != null &&
            kombi.flight._loaderTextIsGlobalRotation === isGlobalRotation
        ) {
            return;
        }

        kombi.flight.stopLoaderTextRotation();
        kombi.flight._loaderTextIsGlobalRotation = isGlobalRotation;

        let currentTextIndex = 0;

        const getContainer = function () {
            // Prefer the live DOM node: HTMX can recreate the loader with the same id.
            const live = document.getElementById("loader-container");
            if (live) return live;

            if (root && root.querySelector) {
                return root.querySelector("#loader-container");
            }

            return null;
        };

        const updateLoaderTextRotation = function () {
            const container = getContainer();
            if (!container) {
                kombi.flight.stopLoaderTextRotation();
                return;
            }

            const texts = container.querySelectorAll(".loader-text");
            if (!texts || texts.length < 2) {
                // With 0/1 texts, nothing to rotate.
                return;
            }

            const current = currentTextIndex % texts.length;
            texts.forEach((textEl) => textEl.classList.add("d-none"));
            texts[current].classList.remove("d-none");
            currentTextIndex = current + 1;
        };

        const initialContainer = getContainer();
        const rotationIntervalMs =
            parseFloat(
                initialContainer?.getAttribute("data-flight-loader-text-interval") || "5",
                10,
            ) * 1000;

        updateLoaderTextRotation();
        kombi.flight._loaderTextIntervalId = window.setInterval(
            updateLoaderTextRotation,
            Math.max(800, rotationIntervalMs),
        );
    },
    // Backwards compatible alias (used in templates / other scripts)
    initLoaderTextRotation: function (root) {
        kombi.flight.startLoaderTextRotation(root);
    },
    stopLoaderTextRotation: function () {
        if (kombi.flight._loaderTextIntervalId != null) {
            window.clearInterval(kombi.flight._loaderTextIntervalId);
            kombi.flight._loaderTextIntervalId = null;
        }
        kombi.flight._loaderTextIsGlobalRotation = null;
    },
}